import { all } from 'redux-saga/effects';
import { authSagas } from './auth';
import { billingSagas } from './billing';
import { domainsSagas } from './domains';
import { emailsSagas } from './emails';
import { sitesSagas } from './sites';
import { productsSagas } from './products';
import { dnsWizardSagas } from './dnsWizard';
import { faqSagas } from './faq';
import { invoicesSagas } from './invoices';
import { asaasSagas } from './asaas';
import { preChatSagas } from './preChat';
import { formsSagas } from './forms';
import { backupSagas } from './backup';
import { securitySagas } from './security';
import { linkNaBioSagas } from './linkNaBio';
import { videoClassesSagas } from './videoClasses';
import { cloudflareSagas } from './cloudflare';
import { commonSagas } from './common';
import { logoBuilderSagas } from './logoBuilder';
import { onboardingSagas } from './onboarding';
import { homeSagas } from './home';
import { studioSagas } from './studio';
import { merlinSagas } from './merlin';
import { fastCheckoutSagas } from './fastcheckout';
import { agentsFactorySagas } from './agentsFactory';
import { adsHandlerSagas } from './adsHandler';

const sagas = [
  authSagas(),
  billingSagas(),
  domainsSagas(),
  emailsSagas(),
  sitesSagas(),
  productsSagas(),
  faqSagas(),
  dnsWizardSagas(),
  invoicesSagas(),
  asaasSagas(),
  preChatSagas(),
  formsSagas(),
  backupSagas(),
  securitySagas(),
  linkNaBioSagas(),
  videoClassesSagas(),
  cloudflareSagas(),
  commonSagas(),
  logoBuilderSagas(),
  onboardingSagas(),
  homeSagas(),
  studioSagas(),
  merlinSagas(),
  fastCheckoutSagas(),
  agentsFactorySagas(),
  adsHandlerSagas(),
];

function* rootSaga() {
  yield all(sagas);
}

export default rootSaga;
